<div>
  <mat-card>
    <mat-card-title class="title-center">Student List</mat-card-title>
  
    <div class="outer-scroll-wrapper">
      <div class="inner-scroll-container mat-elevation-z8">
        <table mat-table [dataSource]="students" class="full-width-table">
  
          <!-- Actions -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> Actions </th>
            <td mat-cell *matCellDef="let student">
              <button mat-icon-button [matMenuTriggerFor]="menu">
                <mat-icon><b>⋮</b></mat-icon>
              </button>
          
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="onEdit(student)">
                  <mat-icon>edit</mat-icon>
                  <span>Edit</span>
                </button>
                <button mat-menu-item (click)="onDelete(student)">
                  <mat-icon>delete</mat-icon>
                  <span>Delete</span>
                </button>
              </mat-menu>
            </td>
          </ng-container>
          
          
          
  
          <ng-container matColumnDef="sno">
            <th mat-header-cell *matHeaderCellDef> S.No. </th>
            <td mat-cell *matCellDef="let row; let i = index">
              {{ currentPage + i + 1 }}
            </td>
          </ng-container>
  
          <!-- Define columns -->
          <ng-container matColumnDef="register_no">
            <th mat-header-cell *matHeaderCellDef> Registration No </th>
            <td mat-cell *matCellDef="let s"> {{ s.register_no }} </td>
          </ng-container>

          <ng-container matColumnDef="semester_number">
            <th mat-header-cell *matHeaderCellDef> Semister No </th>
            <td mat-cell *matCellDef="let s"> {{ s.semester_number }} </td>
          </ng-container>
  
          <ng-container matColumnDef="exam_month">
            <th mat-header-cell *matHeaderCellDef> Exam Month </th>
            <td mat-cell *matCellDef="let s"> {{ s.exam_month }} </td>
          </ng-container>
  
          <ng-container matColumnDef="exam_year">
            <th mat-header-cell *matHeaderCellDef> Exam Year </th>
            <td mat-cell *matCellDef="let s"> {{ s.exam_year }} </td>
          </ng-container>
  
          <ng-container matColumnDef="raw_total_sub1">
            <th mat-header-cell *matHeaderCellDef>Row Sub1</th>
            <td mat-cell *matCellDef="let s"> {{ s.raw_total_sub1 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="processed_total_sub1">
            <th mat-header-cell *matHeaderCellDef> Processed Sub1 </th>
            <td mat-cell *matCellDef="let s"> {{ s.processed_total_sub1 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="grade_sub1">
            <th mat-header-cell *matHeaderCellDef>Grade Sub1 </th>
            <td mat-cell *matCellDef="let s"> {{ s.grade_sub1 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="earned_credits_sub1">
            <th mat-header-cell *matHeaderCellDef>Earned earned Sub1</th>
            <td mat-cell *matCellDef="let s"> {{ s.earned_credits_sub1 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="grade_points_sub1">
            <th mat-header-cell *matHeaderCellDef>Grade Point Earned Sub1 </th>
            <td mat-cell *matCellDef="let s"> {{ s.grade_points_sub1 }} </td>
          </ng-container>

          <ng-container matColumnDef="raw_total_sub2">
            <th mat-header-cell *matHeaderCellDef>Row Sub2</th>
            <td mat-cell *matCellDef="let s"> {{ s.raw_total_sub2 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="processed_total_sub2">
            <th mat-header-cell *matHeaderCellDef> Processed Sub2 </th>
            <td mat-cell *matCellDef="let s"> {{ s.processed_total_sub2 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="grade_sub2">
            <th mat-header-cell *matHeaderCellDef>Grade Sub2 </th>
            <td mat-cell *matCellDef="let s"> {{ s.grade_sub2 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="earned_credits_sub2">
            <th mat-header-cell *matHeaderCellDef>Earned earned Sub2</th>
            <td mat-cell *matCellDef="let s"> {{ s.earned_credits_sub2 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="grade_points_sub2">
            <th mat-header-cell *matHeaderCellDef>Grade Point Earned Sub2 </th>
            <td mat-cell *matCellDef="let s"> {{ s.grade_points_sub2 }} </td>
          </ng-container>

          <ng-container matColumnDef="raw_total_sub3">
            <th mat-header-cell *matHeaderCellDef>Row Sub3</th>
            <td mat-cell *matCellDef="let s"> {{ s.raw_total_sub3 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="processed_total_sub3">
            <th mat-header-cell *matHeaderCellDef> Processed Sub3 </th>
            <td mat-cell *matCellDef="let s"> {{ s.processed_total_sub3 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="grade_sub3">
            <th mat-header-cell *matHeaderCellDef>Grade Sub3 </th>
            <td mat-cell *matCellDef="let s"> {{ s.grade_sub3 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="earned_credits_sub3">
            <th mat-header-cell *matHeaderCellDef>Earned earned Sub3</th>
            <td mat-cell *matCellDef="let s"> {{ s.earned_credits_sub3 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="grade_points_sub3">
            <th mat-header-cell *matHeaderCellDef>Grade Point Earned Sub3 </th>
            <td mat-cell *matCellDef="let s"> {{ s.grade_points_sub3 }} </td>
          </ng-container>

          <ng-container matColumnDef="raw_total_sub4">
            <th mat-header-cell *matHeaderCellDef>Row Sub4</th>
            <td mat-cell *matCellDef="let s"> {{ s.raw_total_sub4 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="processed_total_sub4">
            <th mat-header-cell *matHeaderCellDef> Processed Sub4 </th>
            <td mat-cell *matCellDef="let s"> {{ s.processed_total_sub4 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="grade_sub4">
            <th mat-header-cell *matHeaderCellDef>Grade Sub4 </th>
            <td mat-cell *matCellDef="let s"> {{ s.grade_sub4 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="earned_credits_sub4">
            <th mat-header-cell *matHeaderCellDef>Earned earned Sub4</th>
            <td mat-cell *matCellDef="let s"> {{ s.earned_credits_sub4 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="grade_points_sub4">
            <th mat-header-cell *matHeaderCellDef>Grade Point Earned Sub4 </th>
            <td mat-cell *matCellDef="let s"> {{ s.grade_points_sub4 }} </td>
          </ng-container>

          <ng-container matColumnDef="raw_total_sub5">
            <th mat-header-cell *matHeaderCellDef>Row Sub5</th>
            <td mat-cell *matCellDef="let s"> {{ s.raw_total_sub5 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="processed_total_sub5">
            <th mat-header-cell *matHeaderCellDef> Processed Sub5 </th>
            <td mat-cell *matCellDef="let s"> {{ s.processed_total_sub5 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="grade_sub5">
            <th mat-header-cell *matHeaderCellDef>Grade Sub5 </th>
            <td mat-cell *matCellDef="let s"> {{ s.grade_sub5 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="earned_credits_sub5">
            <th mat-header-cell *matHeaderCellDef>Earned earned Sub5</th>
            <td mat-cell *matCellDef="let s"> {{ s.earned_credits_sub5 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="grade_points_sub5">
            <th mat-header-cell *matHeaderCellDef>Grade Point Earned Sub5 </th>
            <td mat-cell *matCellDef="let s"> {{ s.grade_points_sub5 }} </td>
          </ng-container>

          <ng-container matColumnDef="raw_total_sub6">
            <th mat-header-cell *matHeaderCellDef>Row Sub6</th>
            <td mat-cell *matCellDef="let s"> {{ s.raw_total_sub6 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="processed_total_sub6">
            <th mat-header-cell *matHeaderCellDef> Processed Sub6 </th>
            <td mat-cell *matCellDef="let s"> {{ s.processed_total_sub6 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="grade_sub6">
            <th mat-header-cell *matHeaderCellDef>Grade Sub6 </th>
            <td mat-cell *matCellDef="let s"> {{ s.grade_sub6 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="earned_credits_sub6">
            <th mat-header-cell *matHeaderCellDef>Earned earned Sub6</th>
            <td mat-cell *matCellDef="let s"> {{ s.earned_credits_sub6 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="grade_points_sub6">
            <th mat-header-cell *matHeaderCellDef>Grade Point Earned Sub6 </th>
            <td mat-cell *matCellDef="let s"> {{ s.grade_points_sub6 }} </td>
          </ng-container>

          <ng-container matColumnDef="raw_total_sub7">
            <th mat-header-cell *matHeaderCellDef>Row Sub7</th>
            <td mat-cell *matCellDef="let s"> {{ s.raw_total_sub7 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="processed_total_sub7">
            <th mat-header-cell *matHeaderCellDef> Processed Sub7 </th>
            <td mat-cell *matCellDef="let s"> {{ s.processed_total_sub7 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="grade_sub7">
            <th mat-header-cell *matHeaderCellDef>Grade Sub7 </th>
            <td mat-cell *matCellDef="let s"> {{ s.grade_sub7 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="earned_credits_sub7">
            <th mat-header-cell *matHeaderCellDef>Earned earned Sub7</th>
            <td mat-cell *matCellDef="let s"> {{ s.earned_credits_sub7 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="grade_points_sub7">
            <th mat-header-cell *matHeaderCellDef>Grade Point Earned Sub7 </th>
            <td mat-cell *matCellDef="let s"> {{ s.grade_points_sub7 }} </td>
          </ng-container>

          <ng-container matColumnDef="raw_total_sub8">
            <th mat-header-cell *matHeaderCellDef>Row Sub8</th>
            <td mat-cell *matCellDef="let s"> {{ s.raw_total_sub8 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="processed_total_sub8">
            <th mat-header-cell *matHeaderCellDef> Processed Sub8 </th>
            <td mat-cell *matCellDef="let s"> {{ s.processed_total_sub8 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="grade_sub8">
            <th mat-header-cell *matHeaderCellDef>Grade Sub8 </th>
            <td mat-cell *matCellDef="let s"> {{ s.grade_sub8 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="earned_credits_sub8">
            <th mat-header-cell *matHeaderCellDef>Earned earned Sub8</th>
            <td mat-cell *matCellDef="let s"> {{ s.earned_credits_sub8 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="grade_points_sub8">
            <th mat-header-cell *matHeaderCellDef>Grade Point Earned Sub8 </th>
            <td mat-cell *matCellDef="let s"> {{ s.grade_points_sub8 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="overall_raw_total">
            <th mat-header-cell *matHeaderCellDef>Overal Row Total</th>
            <td mat-cell *matCellDef="let s"> {{ s.overall_raw_total }} </td>
          </ng-container>
  
          <ng-container matColumnDef="overall_processed_total">
            <th mat-header-cell *matHeaderCellDef>Overal Processed Total</th>
            <td mat-cell *matCellDef="let s"> {{ s.overall_processed_total || '-' }} </td>
          </ng-container>
  
          <ng-container matColumnDef="overall_result">
            <th mat-header-cell *matHeaderCellDef>Overal Result</th>
            <td mat-cell *matCellDef="let s"> {{ s.overall_result }} </td>
          </ng-container>

          <ng-container matColumnDef="total_percentage">
            <th mat-header-cell *matHeaderCellDef>Overal Result</th>
            <td mat-cell *matCellDef="let s"> {{ s.total_percentage }} </td>
          </ng-container>

          <ng-container matColumnDef="total_earned_credits">
            <th mat-header-cell *matHeaderCellDef>Total earned Credit</th>
            <td mat-cell *matCellDef="let s"> {{ s.total_earned_credits }} </td>
          </ng-container>

          <ng-container matColumnDef="weighted_grade_points">
            <th mat-header-cell *matHeaderCellDef>Weighted Grade Points</th>
            <td mat-cell *matCellDef="let s"> {{ s.weighted_grade_points }} </td>
          </ng-container>

          <ng-container matColumnDef="attempt_count">
            <th mat-header-cell *matHeaderCellDef>atempeted count</th>
            <td mat-cell *matCellDef="let s"> {{ s.attempt_count }} </td>
          </ng-container>

          <ng-container matColumnDef="sgpa">
            <th mat-header-cell *matHeaderCellDef>SGPA</th>
            <td mat-cell *matCellDef="let s"> {{ s.sgpa }} </td>
          </ng-container>

          <ng-container matColumnDef="cgpa">
            <th mat-header-cell *matHeaderCellDef>CGPA count</th>
            <td mat-cell *matCellDef="let s"> {{ s.cgpa }} </td>
          </ng-container>
  
          <!-- Header and Row -->
          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    </div>
    <mat-paginator
              [pageSizeOptions]="[5, 10, 15, 20]"
              [length]="pagination.length"
              [pageIndex]="pagination.page - 1"
              [pageSize]="pagination.limit"
              (page)="pageEvent($event)"
              *ngIf="pagination.length">
  </mat-paginator>
  </mat-card>
</div>